var utils = require('../../utils')
import AppHeader from '../AppHeader'

export default {
  name: 'message',
  created () {
  },
  data () {
    return {
      csvFileName: null,
      canValidate: true,
      message: {
        start_date: null,
        end_date: null
      }
    }
  },
  computed: {
    validation: function () {
      var v = {
        integrity: this.message.start_date > this.message.end_date,
        not_input: (!!this.message.start_date) &&
                   (!!this.message.end_date) &&
                   (this.message.start_date <= this.message.end_date)
      }
      if (!this.canValidate) {
        Object.keys(v).forEach(key => { v[key] = true; });
      }
      return v
    },
    isValid () {
      var validation = this.validation
      return Object.keys(validation).every(function (key) {
        return validation[key]
      })
    },
    messageManagers () {
      return this.$store.getters.messageManagers
    },
    messageOfficers () {
      return this.$store.getters.messageOfficers
    },
    messageHarassments () {
      return this.$store.getters.messageHarassments
    },
    start_date: function() {
      return this.message.start_date.getFullYear() + '-' + ("0" + (this.message.start_date.getMonth() + 1)).slice(-2) + '-' + ("0" + this.message.start_date.getDate()).slice(-2)
    },
    end_date: function() {
      return this.message.end_date.getFullYear() + '-' + ("0" + (this.message.end_date.getMonth() + 1)).slice(-2) + '-' + ("0" + this.message.end_date.getDate()).slice(-2)
    },
    isOfficer () {
      return window.localStorage.getItem('is_officer') === '1'
    },
    isShopMaster () {
      return window.localStorage.getItem('is_shop_master') === '1'
    },
    isHarassment () {
      return window.localStorage.getItem('is_harassment') === '1'
    }
  },
  components: {
    AppHeader
  },
  methods: {
    downloadCsv: function () {
      var self = this
      var data = {}
      data.start_date = this.start_date
      data.end_date = this.end_date

      var callback = function() {
        self.csvFileName = self.start_date.replace( /-/g, '') + '-' + self.end_date.replace( /-/g, '') + '_' + 'メッセージ' +'.csv'

        var bom = new Uint8Array([0xEF, 0xBB, 0xBF])
        var mimeType = 'text/csv'
        var csv = '送信日時,送信者ID,送信者名,送信者名（ふりがな）,送信者店舗名,送信者役職名,送信者離職日,受信者ID,受信者名,受信者名（ふりがな）,受信者店舗名,受信者役職名,メッセージ内容,既読未読区分\n'

        if (self.isOfficer) {
          self.messageOfficers.forEach(function (obj) {
            csv += self.csvLine(obj)
          })
        }
        if (self.isOfficer || self.isShopMaster) {
          self.messageManagers.forEach(function (obj) {
            csv += self.csvLine(obj)
          })
        }
        if (self.isHarassment) {
          self.messageHarassments.forEach(function (obj) {
            csv += self.csvLine(obj)
          })
        }

        var blob = new Blob([bom, csv], { type: mimeType })
        var hiddenElement = document.createElement('a')
        hiddenElement.download = self.csvFileName
        hiddenElement.target = '_blank'
        if(window.navigator.msSaveBlob) {
          window.navigator.msSaveBlob(blob, self.csvFileName)
        } else if (window.URL && window.URL.createObjectURL){
          hiddenElement.href = window.URL.createObjectURL(blob)
          document.body.appendChild(hiddenElement)
          hiddenElement.click()
          document.body.removeChild(hiddenElement)
        } else if (window.webkitURL && window.webkitURL.createObject) {
          hiddenElement.href = (window.URL || window.webkitURL).createObjectURL(blob)
          hiddenElement.click()
        } else {
          window.open('data:' + mimeType + ';base64,' + window.Base64.encode(content), '_blank')
        }
      }
      self.$store.dispatch('MESSAGE_DATA_DOWNLOAD', { data : data, callback : callback })
    },
    onClickCancel: function () {
      this.$router.push({ path: '/', query: { type: this.$router.currentRoute.query.type}})
    },
    enquoteForCSV: function(val) {
      if (!val) return val
      if (/[",\r\n]/.test(val)) { //",\r\nが含まれる場合はenquoteする
        val = '"' + val.replace(/"/g, '""') + '"';
      }
      return val
    },
    csvLine: function(obj) {
      var self = this
      var csv = ''
      if (obj.attributes['created-at-format']) {
        csv += obj.attributes['created-at-format'].replace( /[-,]/g, '/') + ','
      } else {
        csv += ','
      }
      if (obj.attributes['send-user-id']) {
        csv += obj.attributes['send-user-id'] + ','
      } else {
        csv += ','
      }
      if (obj.attributes['send-user-name']) {
        csv += self.enquoteForCSV(obj.attributes['send-user-name']) + '　' + self.enquoteForCSV(obj.attributes['send-user-firstname']) + ','
      } else {
        csv += ','
      }
      if (obj.attributes['send-user-name-furigana'] && obj.attributes['send-user-firstname-furigana']) {
        csv += self.enquoteForCSV(obj.attributes['send-user-name-furigana']) + '　' + self.enquoteForCSV(obj.attributes['send-user-firstname-furigana']) + ','
      } else {
        csv += ','
      }
      if (obj.attributes['send-user-shop-name']) {
        csv += self.enquoteForCSV(obj.attributes['send-user-shop-name']) + ','
      } else {
        csv += ','
      }
      if (obj.attributes['send-user-type-name']) {
        csv += self.enquoteForCSV(obj.attributes['send-user-type-name']) + ','
      } else {
        csv += ','
      }
      if (obj.attributes['send-user-overday-format']) {
        csv += obj.attributes['send-user-overday-format'].replace( /[-,]/g, '/') + ','
      } else {
        csv += ','
      }
      if (obj.attributes['recieve-user-id']) {
        csv += obj.attributes['recieve-user-id'] + ','
      } else {
        csv += ','
      }
      if (obj.attributes['recieve-user-name']) {
        csv += self.enquoteForCSV(obj.attributes['recieve-user-name']) + '　' + self.enquoteForCSV(obj.attributes['recieve-user-firstname']) + ','
      } else {
        csv += ','
      }
      if (obj.attributes['recieve-user-name-furigana'] && obj.attributes['recieve-user-firstname-furigana']) {
        csv += self.enquoteForCSV(obj.attributes['recieve-user-name-furigana']) + '　' + self.enquoteForCSV(obj.attributes['recieve-user-firstname-furigana']) + ','
      } else {
        csv += ','
      }
      if (obj.attributes['recieve-user-shop-name']) {
        csv += self.enquoteForCSV(obj.attributes['recieve-user-shop-name']) + ','
      } else {
        csv += ','
      }
      if (obj.attributes['recieve-user-type-name']) {
        csv += self.enquoteForCSV(obj.attributes['recieve-user-type-name']) + ','
      } else {
        csv += ','
      }
      if (obj.attributes['content']) {
        csv += self.enquoteForCSV(obj.attributes['content']) + ','
      } else {
        csv += ','
      }
      if (obj.attributes['is-already-read'] === 0) {
        csv += '未読'
      } else if (obj.attributes['is-already-read'] === 1) {
        csv += '既読'
      }
      csv += "\n"
      return csv
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/message.js